import { render, staticRenderFns } from "./year-range.vue?vue&type=template&id=07136392&"
import script from "./year-range.vue?vue&type=script&lang=js&"
export * from "./year-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports